import React, { Component } from "react";
import { MDBDataTable, MDBContainer } from 'mdbreact';
import styled from 'styled-components';

const MDBContainerPop = styled(MDBContainer)`
  padding: 0.1rem 1rem;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 5;
  background-color: white;
  box-sizing: border-box;
  border: 1px solid gray;
  border-radius: 0.3rem;
`;

class DetailCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      productMac: this.props.detialMacId,
      serialNumber: this.props.detialSerial,
      logArray: [],
      presentedArray: []
    }
  }

  componentDidMount() {
    fetch(`${global.gConfig.backend.url}/devicesetting?_filter={"macAddress":"${this.state.productMac}"}`)
      .then( res => res.json())
      .then( results => {
        let data = {
          columns: [
            {
              label: 'Log time',
              field: 'log',
              sort: 'asc',
              width: 150
            },
            {
              label: 'Firm Version',
              field: 'FV',
              sort: 'asc',
              width: 100
            },
            {
              label: 'App version',
              field: 'AV',
              sort: 'asc',
              width: 100
            },
            {
              label: 'Settings',
              field: 'settings',
              sort: 'asc',
              width: 150
            },
            {
              label: 'Counters',
              field: 'counters',
              sort: 'asc',
              width: 150
            }
          ],
          rows: []
        }

        results.forEach((value, index, array) => {
          let countersArray = value.counters.split(",");
          let settingsArray = JSON.parse(value.settings);
          let resolution = "";
          let area = ['Narrow', 'Middle', 'Wide'];

          if ( settingsArray.rec.indexOf('1920') !== -1 ) {
            resolution = "FHD";
          }

          data.rows[index] = {
            log: value.createdAt,
            FV: value.firmwareVersion,
            AV: value.appVersion,
            settings: `${resolution} ${area[settingsArray.crop]}`,
            counters: `${countersArray[0]},${countersArray[2]},${countersArray[10]},${countersArray[63]}`
          }
        })

        this.setState({logArray: results, presentedArray: data});
      })
      .catch( err => {console.log(err)} )
  }

  render() {
    return (
      <MDBContainerPop fluid>
        <button onClick={(e) => {this.props.onDetialCancel(e)}} type="button" className="close" aria-label="Close">
          <span aria-hidden="true">×</span>
        </button>
        <h3><strong>Activities</strong></h3>
        <dl className="row">
          <dt className="col-sm-3">Mac Address</dt>
          <dd className="col-sm-3">{this.state.productMac}</dd>

          <dt className="col-sm-3">serialNumber</dt>
          <dd className="col-sm-3">{this.state.serialNumber}</dd>
        </dl>
        <MDBDataTable
          scrollY
          scrollX
          striped
          hover
          data={this.state.presentedArray}
        />
      </MDBContainerPop>
    );
  }
}

export default DetailCard;
